module.exports = __webpack_public_path__ + "img/154.4f8d16e7.jpg";